import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import classNames from "classnames";

import config from "../../shards-pro/config.json";

class Dropdown extends Component {
    render() {
        return (
            <DropdownWrapper>
                <Button to="/">Categories</Button>
                <DropdownList className={classNames('dropdown-list')}>
                    {config.categories.map((cat, idx) => <li key={idx}><Link to={cat.path}>{cat.title}</Link></li>)}
                </DropdownList>
            </DropdownWrapper>
        );
    }

    handleOnClick() {
        this.setState({
            visible: !this.state.visible
        });
    }
}

export default Dropdown;

const DropdownWrapper = styled.div`
    position: relative;
    margin-left: auto;
    z-index: 1000;
`;

const DropdownList = styled.ul`
    visibility: hidden;
    opacity: 0;
    position: absolute;
    width: 160px;
    background: #fff;
    list-style: none;
    margin: 0;
    padding: 10px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0;
    right: 0;
    box-shadow: 0 0 30px rgba(0,0,0,.05), 0 3px 10px rgba(0,0,0,.1), 0 2px 2px rgba(23, 47, 139, 0.17);
    transition: all 250ms ease-in;

    @media (max-width: 576px) {
        left: 0;
        width: 200px;
        max-height: 100vh;
    }

    &:hover {
        visibility: visible;
        opacity: 1;
    }

    li {
        display: block;
        border-bottom: 1px solid #dadee2;
        
        &:last-child {
            border: 0;
        }

        a {
            padding: 12px 20px;
            display: block;
            text-decoration: none;
            font-size: 14px;
            color: #787a91;
            transition: all 250ms ease-in-out;

            @media (max-width: 576px) {
                font-size: 12px;
            }

            &:hover {
                color: #2d53fe;
                background: #f9fcff;
            }
        }
    }

    &.visible {
        display: block;
    }
`;

const Button = styled(Link)`
    display: block;
    text-decoration: none;
    background: none;
    border: none;
    border: 1px solid #c6cbd4;
    padding: 10px 15px;
    border-radius: 5px;
    font-size: 14px;
    color: #787a91;
    transition: all 200ms ease-in-out !important;

    &:hover {
        color: #2d53fe;
        border-color: #2d53fe;
    }

    &:hover {
        cursor: pointer;
    }

    &:hover + .dropdown-list {
        visibility: visible;
        opacity: 1;
    }

    &:focus {
        outline: 0;
    }
`;